/* eslint-disable no-useless-escape */
const detectAndWrapLinks = (text: string): string => {
  const urlRegex = /\[([^\[]+)\](\(.*\))/gm;

  return text.replace(urlRegex, (regexString) => {
    const label = regexString.match(/\[([^\[]+)\]/);
    const url = regexString.match(/\((.*)\)/);

    if (!label || !url) {
      return regexString;
    }

    return `<a href="${url[1]}" target="_blank">${label[1]}</a>`;
  });
};

export default detectAndWrapLinks;
